import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";

// SocialIcon Component
const SocialIcon = ({ platform, link, target }) => (
  <li className="social-icon-item">
    <a
      href={link}
      className={`social-icon-link bi-${platform}`}
      target={target}
    ></a>
  </li>
);

// FooterMenu Component
const FooterMenu = ({ items, heading, className }) => (
  <div className={`col-lg-3 col-md-6 col-12 mb-4 footer-space footer-item-list ${className}`}>
    <h5 className="site-footer-title mb-3">{heading}</h5>
    <ul className="footer-menu">
      {items.map((item, index) => (
        <li key={index} className="footer-menu-item">
          <Link to={item.path} className="footer-menu-link">
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

// FooterContact Component
const FooterContact = ({ phone, email, address }) => (
  <div className="col-lg-4 col-md-6 col-12 mx-auto mb-text-left">
    <h5 className="site-footer-title mb-3">Contact Information</h5>

    <p className="text-white d-flex mb-2">
      <i className="bi-telephone me-2"></i>
      <a href={`tel:${phone}`} className="site-footer-link">
        {phone}
      </a>
    </p>

    <p className="text-white d-flex">
      <i className="bi-envelope me-2"></i>
      <a href={`mailto:${email}`} className="site-footer-link">
        {email}
      </a>
    </p>

    <p className="text-white d-flex mt-3">
      <i className="bi-geo-alt me-2"></i>
      <span className="text-white" dangerouslySetInnerHTML={{ __html: address }} />
    </p>
  </div>
);

// Footer Component
const Footer = () => {
  const menuLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Certificates", path: "/credentials" },
    { name: "Contact", path: "/contact" },
  ];

  const productsServicesLinks = [
    { name: "Polypropylene", path: "/business/Polypropylene" },
    { name: "Construction", path: "/business/Construction" },
    { name: "Tyre", path: "/business/Tyre" },
    { name: "Chemical", path: "/business/api-excipients" },
    { name: "Metals & Mineral Resources", path: "/business/metals-minerals" },
    { name: "Agricultural Commodities", path: "/business/agricultural-commodities" },
    { name: "Edible & Essential Oils", path: "/business/edible-essential-oils" },
    { name: "EcoPalm Products", path: "/business/ecopalm-products" },
  ];

  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row">
          {/* Menu Section */}
          <FooterMenu items={menuLinks} heading="Menu" />

          {/* Products & Services Section */}
          <FooterMenu
            className="products-offered"
            items={productsServicesLinks}
            heading="Products"
          />

          {/* Contact Information Section */}
          <FooterContact
            phone="+912246639598"
            email="info@dohrniiexim.com"
            address={`Z1-3090, Akshar Business Park, Vashi,<br/>Navi Mumbai 400705, Maharashtra, India.`}
          />
        </div>

        {/* DUNS iframe */}
        <div className="duns-iframe mb-4">
          <iframe
            id="Iframe1"
            src="https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1"
            width="114px"
            height="97px"
            frameBorder="0"
            scrolling="no"
            allowTransparency="true"
          ></iframe>
        </div>
      </div>

      <div className="site-footer-bottom">
        <div className="container">
          <div className="row j-cont-cent">
            <div className="col-lg-6 col-md-7 col-12">
              <p className="copyright-text mb-0">
                Copyright &copy; {currentYear + " "}
                <Link to="/">Dohrnii Exim Pvt Ltd. </Link> All rights reserved.
                <br />
                <span className="developer-name">
                  SEO & Design and Developed By{" "}
                  <a
                    href="https://www.linkedin.com/in/adarsh-mishra11/"
                    target="_blank"
                  >
                    Adarsh Mishra
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://www.linkedin.com/in/devmani-mishra-7775352aa/"
                    target="_blank"
                  >
                    Devmani Mishra
                  </a>{" "}
                </span>
              </p>
            </div>

            {/* Uncomment this section if you want social icons */}
            {/* <div className="col-lg-6 col-md-5 col-12 d-flex justify-content-center align-items-center mx-auto">
              <ul className="social-icon">
                <SocialIcon
                  platform="twitter"
                  target="_blank"
                  link="https://x.com"
                />
                <SocialIcon
                  platform="facebook"
                  target="_blank"
                  link="https://facebook.com"
                />
                <SocialIcon
                  platform="instagram"
                  target="_blank"
                  link="https://instagram.com"
                />
                <SocialIcon
                  platform="linkedin"
                  target="_blank"
                  link="https://linkedin.com"
                />
                <SocialIcon
                  platform="youtube"
                  target="_blank"
                  link="https://youtube.com/"
                />
              </ul>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;